export default __webpack_public_path__ + "static/media/14.d636bf81.mp4";